import { ListItem, LocallyFilteringList } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { ISalesforceApp } from '../restApi/requests/GetSalesforceApps';
import { PublishToSalesforceDialogStyles } from '../styles/PublishToSalesforceDialogStyles';

export interface SalesforceAppsViewProps {
    readonly salesforceApps: ISalesforceApp[];
    readonly onSelect: (selectedApp: string) => void;
    readonly selectedAppValue: string;
}

interface SalesforceAppsListItem extends ListItem {
    content: string;
}

const privateAppDescription: string = '  (Private to me)';

export class SalesforceAppsView extends React.Component<SalesforceAppsViewProps> {
    private privateAppId: string;

    salesforceAppsFilter = (item: SalesforceAppsListItem, filter: string) => {
        const appName = item.value === this.privateAppId ? (item.content.replace(privateAppDescription, '')) : item.content;
        return appName.toLowerCase().includes(filter.toLowerCase())
            || (item.value === this.props.selectedAppValue);
    };

    private convertSalesforceAppListToListItemArrayWithGrouping(): SalesforceAppsListItem[] {
        // Converting salesforceApps response to a listItem array
        let salesforceAppsInListItemArray: SalesforceAppsListItem[] = [];
        this.props.salesforceApps.forEach((salesforceApp: ISalesforceApp) => {
            let appInfo: SalesforceAppsListItem = {
                content: salesforceApp.label,
                value: salesforceApp.id,
                testId: `${salesforceApp.id}-destination-app`,
            };
            if (salesforceApp.isPrivateApp === true) {
                this.privateAppId = salesforceApp.id;
                appInfo.content = appInfo.content.concat(privateAppDescription);
                salesforceAppsInListItemArray.splice(0, 0, appInfo);
            } else {
                salesforceAppsInListItemArray.push(appInfo);
            }
        });
        return salesforceAppsInListItemArray;
    }

    public render() {
        return (
            <LocallyFilteringList
                onSelect={this.props.onSelect}
                items={this.convertSalesforceAppListToListItemArrayWithGrouping()}
                inputTestId={'salesforce-apps-list-search'}
                listTestId={'salesforce-apps-list'}
                selectedValue={this.props.selectedAppValue}
                itemFilterFn={this.salesforceAppsFilter}
                style={PublishToSalesforceDialogStyles.FilteringListStyle}
                searchPlaceholder={Messages.publishToSalesforceDialogSearchPlaceholder()}
            />
        );
    }
}
